<template>
  <b-form-group
    label="Kira Başlangıç"
    label-for="sdate"
  >
    <b-form-datepicker
      id="sdate"
      v-model="dataItem.sdate"
      v-bind="{labelNoDateSelected: 'Tarih Seçiniz',labelHelp: 'Ok tuşlarıyla takvimde gezinin'}"
      locale="tr"
      start-weekday="1"
    />
  </b-form-group>
</template>
<script>
import {
  BFormGroup, BFormDatepicker,
} from 'bootstrap-vue'

export default {
  name: 'TenantSelect',
  components: {
    BFormGroup,
    BFormDatepicker,
  },
  computed: {
    dataItem() {
      return this.$store.getters['estateTenants/dataItem']
    },
    dataList() {
      return this.$store.getters['tenants/dataList']
    },
  },
  created() {
    this.getDataList()
  },
  methods: {
    getDataList() {
      this.$store.dispatch('tenants/getDataList')
    },
  },
}
</script>
